import { useEffect, useState } from 'react'
import Image from 'next/image'

export function Map() {
  const [isMapLoaded, setMapLoaded] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    let map
    // @ts-ignore
    import('datamaps').then((mod) => {
      setMapLoaded(true)
      const Datamap = mod.default
      map = new Datamap({
        element: document.getElementById('map'),
        scope: 'world',
        projection: 'equirectangular',
        responsive: true,
        aspectRatio: 0.42,
        geographyConfig: {
          popupOnHover: !1,
          highlightOnHover: !1,
          borderColor: '#f8fafc',
        },
        fills: {
          single: '#608bd8',
          multiple: '#608bd8',
          planned: '#ffff',
          upgrade: '#608bd8',
          defaultFill: '#EBF0F3',
        },
        bubblesConfig: {
          borderWidth: 2,
          radius: Math.max(600, Math.min(window.innerWidth, 1000)) * 0.005,
          exitDelay: 0,
          animate: false,
          highlightFillColor: '#3b4c6a',
          highlightBorderColor: '#f8fafc',
        },
      })
      resize()
    })

    function resize() {
      map?.resize()
      map?.bubbles(networkLocations, {
        radius: Math.max(600, Math.min(window.innerWidth, 1000)) * 0.005,
        popupTemplate: function (e, l) {
          return ['<div class="map__hover-info">' + l.name + '</div>'].join('')
        },
      })
    }

    window.addEventListener('resize', resize)

    return () => {
      // Makes hot-reloading work
      const elem = document.getElementById('map')
      if (elem) elem.innerHTML = ''
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <div className='relative'>
      {/* Fallback to image until the map loads */}
      <Image
        src='/edge-location-map.png'
        layout='intrinsic'
        width={1280}
        height={537}
        // No need to load immediately, but load as soon as we mounted
        priority={isMounted}
      />
      <div
        className={`absolute top-0 left-0 bottom-0 right-0 w-full h-full ${
          isMapLoaded ? `bg-gray-50` : `bg-transparent`
        }`}
      >
        <div id='map' />
      </div>
    </div>
  )
}

export const networkLocations = [
  {
    name: 'Accra',
    latitude: 5.6,
    longitude: -0.19,
    fillKey: 'planned',
  },
  {
    name: 'Adelaide',
    latitude: -34.93,
    longitude: 138.6,
    fillKey: 'planned',
  },
  {
    name: 'Amsterdam',
    latitude: 52.36,
    longitude: 4.89,
    fillKey: 'upgrade',
  },
  {
    name: 'Ashburn',
    latitude: 39.04,
    longitude: -77.48,
    fillKey: 'upgrade',
  },
  {
    name: 'Atlanta',
    latitude: 33.74,
    longitude: -84.38,
    fillKey: 'upgrade',
  },
  {
    name: 'Auckland',
    latitude: -36.84,
    longitude: 174.76,
    fillKey: 'single',
  },
  {
    name: 'Bogota',
    latitude: 4.7,
    longitude: -74.07,
    fillKey: 'upgrade',
  },
  {
    name: 'Boston',
    latitude: 42.36,
    longitude: -71.05,
    fillKey: 'single',
  },
  {
    name: 'Brisbane',
    latitude: -27.46,
    longitude: 153.02,
    fillKey: 'upgrade',
  },
  {
    name: 'Brussels',
    latitude: 50.85,
    longitude: 4.35,
    fillKey: 'planned',
  },
  {
    name: 'Buenos Aires',
    latitude: -34.6,
    longitude: -58.38,
    fillKey: 'upgrade',
  },
  {
    name: 'Calgary',
    latitude: 51.04,
    longitude: -114.07,
    fillKey: 'planned',
  },
  {
    name: 'Cape Town',
    latitude: -33.92,
    longitude: 18.42,
    fillKey: 'upgrade',
  },
  {
    name: 'Chennai',
    latitude: 13.08,
    longitude: 80.27,
    fillKey: 'single',
  },
  {
    name: 'Chicago',
    latitude: 41.87,
    longitude: -87.62,
    fillKey: 'upgrade',
  },
  {
    name: 'Columbus',
    latitude: 39.96,
    longitude: -82.99,
    fillKey: 'single',
  },
  {
    name: 'Christchurch',
    latitude: -43.53,
    longitude: 172.63,
    fillKey: 'planned',
  },
  {
    name: 'Copenhagen',
    latitude: 55.67,
    longitude: 12.56,
    fillKey: 'single',
  },
  {
    name: 'Curitiba',
    latitude: -25.48,
    longitude: -49.3,
    fillKey: 'single',
  },
  {
    name: 'Dallas',
    latitude: 32.77,
    longitude: -96.79,
    fillKey: 'multiple',
  },
  {
    name: 'Denver',
    latitude: 39.73,
    longitude: -104.99,
    fillKey: 'single',
  },
  {
    name: 'Detroit',
    latitude: 42.33,
    longitude: -83.05,
    fillKey: 'planned',
  },
  {
    name: 'Dubai',
    latitude: 25.2,
    longitude: 55.27,
    fillKey: 'upgrade',
  },
  {
    name: 'Dublin',
    latitude: 53.34,
    longitude: -6.26,
    fillKey: 'single',
  },
  {
    name: 'Fortaleza',
    latitude: -3.73,
    longitude: -38.53,
    fillKey: 'planned',
  },
  {
    name: 'Frankfurt',
    latitude: 50.11,
    longitude: 8.68,
    fillKey: 'multiple',
  },
  {
    name: 'Helsinki',
    latitude: 60.16,
    longitude: 24.93,
    fillKey: 'upgrade',
  },
  {
    name: 'Hyderabad',
    latitude: 17.38,
    longitude: 78.49,
    fillKey: 'planned',
  },
  {
    name: 'Hong Kong',
    latitude: 22.31,
    longitude: 114.16,
    fillKey: 'single',
  },
  {
    name: 'Honolulu',
    latitude: 21.31,
    longitude: -157.86,
    fillKey: 'planned',
  },
  {
    name: 'Houston',
    latitude: 29.76,
    longitude: -95.36,
    fillKey: 'single',
  },
  {
    name: 'Jacksonville',
    latitude: 30.33,
    longitude: -81.65,
    fillKey: 'upgrade',
  },
  {
    name: 'Jakarta',
    latitude: -6.21,
    longitude: 106.85,
    fillKey: 'planned',
  },
  {
    name: 'Johannesburg',
    latitude: -26.2,
    longitude: 28.04,
    fillKey: 'single',
  },
  {
    name: 'Kansas City',
    latitude: 39.09,
    longitude: -94.58,
    fillKey: 'single',
  },
  {
    name: 'Kolkata',
    latitude: 22.57,
    longitude: 88.36,
    fillKey: 'planned',
  },
  {
    name: 'Kuala Lumpur',
    latitude: 3.14,
    longitude: 101.69,
    fillKey: 'planned',
  },
  {
    name: 'Lima',
    latitude: -12.05,
    longitude: -77.04,
    fillKey: 'planned',
  },
  {
    name: 'Lisbon',
    latitude: 38.72,
    longitude: -9.14,
    fillKey: 'planned',
  },
  {
    name: 'London',
    latitude: 51.5,
    longitude: 0.12,
    fillKey: 'multiple',
  },
  {
    name: 'Los Angeles',
    latitude: 34.05,
    longitude: -118.24,
    fillKey: 'multiple',
  },
  {
    name: 'Madrid',
    latitude: 40.41,
    longitude: -3.7,
    fillKey: 'upgrade',
  },
  {
    name: 'Manila',
    latitude: 14.6,
    longitude: 120.98,
    fillKey: 'planned',
  },
  {
    name: 'Manchester',
    latitude: 53.48,
    longitude: -2.24,
    fillKey: 'single',
  },
  {
    name: 'Marseille',
    latitude: 43.3,
    longitude: 5.37,
    fillKey: 'single',
  },
  {
    name: 'Melbourne',
    latitude: -37.81,
    longitude: 144.96,
    fillKey: 'single',
  },
  {
    name: 'Mexico City',
    latitude: 19.43,
    longitude: -99.13,
    fillKey: 'planned',
  },
  {
    name: 'Miami',
    latitude: 25.76,
    longitude: -80.19,
    fillKey: 'single',
  },
  {
    name: 'Milan',
    latitude: 45.46,
    longitude: 9.19,
    fillKey: 'single',
  },
  {
    name: 'Minneapolis',
    latitude: 44.97,
    longitude: -93.26,
    fillKey: 'single',
  },
  {
    name: 'Montreal',
    latitude: 45.5,
    longitude: -73.56,
    fillKey: 'single',
  },
  {
    name: 'Mumbai',
    latitude: 19.07,
    longitude: 72.87,
    fillKey: 'single',
  },
  {
    name: 'Munich',
    latitude: 48.14,
    longitude: 11.58,
    fillKey: 'planned',
  },
  {
    name: 'Nairobi',
    latitude: -1.29,
    longitude: 36.82,
    fillKey: 'planned',
  },
  {
    name: 'New Delhi',
    latitude: 28.61,
    longitude: 77.2,
    fillKey: 'single',
  },
  {
    name: 'New York',
    latitude: 40.71,
    longitude: -74,
    fillKey: 'multiple',
  },
  {
    name: 'Osaka',
    latitude: 34.69,
    longitude: 135.5,
    fillKey: 'single',
  },
  {
    name: 'Oslo',
    latitude: 59.91,
    longitude: 10.75,
    fillKey: 'single',
  },
  {
    name: 'Paris',
    latitude: 48.85,
    longitude: 2.35,
    fillKey: 'single',
  },
  {
    name: 'Perth',
    latitude: -31.95,
    longitude: 115.86,
    fillKey: 'single',
  },
  {
    name: 'Portland',
    latitude: 45.51,
    longitude: -122.68,
    fillKey: 'single',
  },
  {
    name: 'Phoenix',
    latitude: 33.45,
    longitude: -112.07,
    fillKey: 'single',
  },
  {
    name: 'Rio de Janeiro',
    latitude: -22.9,
    longitude: -43.17,
    fillKey: 'upgrade',
  },
  {
    name: 'Rome',
    latitude: 41.9,
    longitude: 12.5,
    fillKey: 'planned',
  },
  {
    name: 'San Jose',
    latitude: 37.33,
    longitude: -121.88,
    fillKey: 'multiple',
  },
  {
    name: 'Santiago',
    latitude: -33.44,
    longitude: -70.66,
    fillKey: 'upgrade',
  },
  {
    name: 'S\xe3o Paulo',
    latitude: -23.55,
    longitude: -46.63,
    fillKey: 'multiple',
  },
  {
    name: 'Seattle',
    latitude: 47.6,
    longitude: -122.33,
    fillKey: 'upgrade',
  },
  {
    name: 'Seoul',
    latitude: 37.57,
    longitude: 126.98,
    fillKey: 'planned',
  },
  {
    name: 'Singapore',
    latitude: 1.35,
    longitude: 103.81,
    fillKey: 'multiple',
  },
  {
    name: 'Sofia',
    latitude: 42.7,
    longitude: 23.32,
    fillKey: 'planned',
  },
  {
    name: 'St. Louis',
    latitude: 38.63,
    longitude: -90.2,
    fillKey: 'single',
  },
  {
    name: 'Stockholm',
    latitude: 59.32,
    longitude: 18.06,
    fillKey: 'single',
  },
  {
    name: 'Sydney',
    latitude: -33.86,
    longitude: 151.2,
    fillKey: 'single',
  },
  {
    name: 'Taipei',
    latitude: 25.03,
    longitude: 121.57,
    fillKey: 'planned',
  },
  {
    name: 'Tokyo',
    latitude: 35.67,
    longitude: 139.65,
    fillKey: 'upgrade',
  },
  {
    name: 'Toronto',
    latitude: 43.65,
    longitude: -79.38,
    fillKey: 'single',
  },
  {
    name: 'Vancouver',
    latitude: 49.28,
    longitude: -123.12,
    fillKey: 'single',
  },
  {
    name: 'Vienna',
    latitude: 48.2,
    longitude: 16.37,
    fillKey: 'upgrade',
  },
  {
    name: 'Wellington',
    latitude: -41.28,
    longitude: 174.77,
    fillKey: 'single',
  },
].filter((loc) => loc.fillKey !== 'planned')
